// ─── Relatório PG Soluções Inteligentes ──────────────────────────────────────

function fmt(ts) {
  if (!ts) return '--';
  const d = ts.toDate ? ts.toDate() : new Date(ts);
  return d.toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'short' });
}

export function gerarRelatorioPG(os, tecnicoNome, logoUrl, { STATUS_LABELS, STATUS_COLORS_HEX, CHECKLIST_PADRAO, contrato }) {
  const cor      = '#2b6cb0';
  const corLight = '#bee3f8';

  const badgeMap = {
    aprovada:              '#c6f6d5;color:#276749',
    reprovada:             '#fed7d7;color:#9b2c2c',
    aguardando_validacao:  '#feebc8;color:#7b341e',
    rascunho:              '#e2e8f0;color:#4a5568',
    enviada:               '#bee3f8;color:#2c5282',
  };
  const bc = badgeMap[os.status] || '#e2e8f0;color:#4a5568';

  const checklistHtml = CHECKLIST_PADRAO.map(({ id, label }) =>
    `<tr>
      <td style="padding:4px 8px;font-size:15px;">${os.checklist?.[id] ? '✅' : '✗'}</td>
      <td style="padding:4px 8px;${os.checklist?.[id] ? '' : 'text-decoration:line-through;color:#a0aec0;'}">${label}</td>
    </tr>`
  ).join('');

  const fotosHtml = (os.fotos || []).map((f) =>
    `<div style="display:inline-block;margin:6px;vertical-align:top;text-align:center;">
      <img src="${f.url}" style="width:200px;height:150px;object-fit:cover;border-radius:8px;border:1px solid #e2e8f0;"/>
      ${f.legenda ? `<div style="font-size:11px;color:#718096;margin-top:4px;">${f.legenda}</div>` : ''}
    </div>`
  ).join('');

  return `<!DOCTYPE html><html lang="pt-BR"><head><meta charset="UTF-8"/>
    <title>Relatório OS ${os.numeroOS || os.id.slice(-6)} — PG Soluções</title>
    <style>
      *{box-sizing:border-box;} body{font-family:Arial,sans-serif;margin:0;padding:24px;font-size:13px;color:#1a202c;}
      h1{font-size:20px;margin:0 0 4px;}
      h2{font-size:13px;font-weight:700;margin:16px 0 8px;color:${cor};border-bottom:2px solid ${corLight};padding-bottom:4px;text-transform:uppercase;letter-spacing:.04em;}
      .header{display:flex;align-items:flex-start;justify-content:space-between;margin-bottom:16px;border-bottom:3px solid ${cor};padding-bottom:12px;}
      .badge{display:inline-block;padding:3px 10px;border-radius:20px;font-size:11px;font-weight:700;background:${bc.split(';')[0]};}
      .grid{display:grid;grid-template-columns:1fr 1fr;gap:8px 24px;}
      .field{margin-bottom:6px;} .field .lbl{font-size:10px;text-transform:uppercase;font-weight:700;color:#718096;} .field p{margin:2px 0 0;}
      table{border-collapse:collapse;width:100%;} td{vertical-align:middle;}
      .val-box{padding:10px;border-radius:8px;margin-top:8px;}
      .ap-box{background:#f0fff4;border:1px solid #9ae6b4;} .rp-box{background:#fff5f5;border:1px solid #feb2b2;}
      @media print{button{display:none!important;} body{padding:12px;}}
    </style></head><body>
    <div class="header">
      <div style="display:flex;align-items:center;gap:14px;">
        <img src="${logoUrl}" style="height:56px;object-fit:contain;" alt="Logo PG"/>
        <div>
          <div style="font-size:11px;color:#718096;font-weight:700;text-transform:uppercase;letter-spacing:.05em;">PG SOLUÇÕES INTELIGENTES</div>
          <div style="font-size:10px;color:#a0aec0;">Sistema de Gestão de Ordens de Serviço${contrato ? ` &nbsp;&mdash;&nbsp; Contrato ${contrato.numero}` : ''}</div>
          <h1 style="color:${cor};">Ordem de Serviço #${os.numeroOS || os.id.slice(-6)}</h1>
          <span class="badge">${STATUS_LABELS[os.status] || os.status}</span>
        </div>
      </div>
      <div style="text-align:right;font-size:11px;color:#718096;">
        <div>Criada em: <strong>${fmt(os.criadaEm)}</strong></div>
        <div>Atualizada: <strong>${fmt(os.atualizadaEm)}</strong></div>
        ${os.validadaEm ? `<div>Validada: <strong>${fmt(os.validadaEm)}</strong></div>` : ''}
      </div>
    </div>
    <h2>Identificação</h2>
    <div class="grid">
      <div class="field"><div class="lbl">Nº OS</div><p>${os.numeroOS || '--'}</p></div>
      <div class="field"><div class="lbl">Cliente</div><p>${os.cliente || '--'}</p></div>
      ${contrato ? `<div class="field"><div class="lbl">Contrato</div><p>${contrato.numero} &mdash; ${contrato.cidade}</p></div>` : ''}
      <div class="field"><div class="lbl">Tipo de Serviço</div><p>${os.tipoServico || '--'}${os.tipoOutros ? ' (' + os.tipoOutros + ')' : ''}</p></div>
      <div class="field"><div class="lbl">Hora</div><p>${os.hora || '--'}</p></div>
    </div>
    <h2>Técnico Responsável</h2>
    <div class="field"><div class="lbl">Nome</div><p>${tecnicoNome}</p></div>
    <h2>Localização</h2>
    <div class="grid">
      <div class="field"><div class="lbl">Logradouro</div><p>${os.logradouro || '--'}</p></div>
      <div class="field"><div class="lbl">Número</div><p>${os.numero || '--'}</p></div>
      <div class="field"><div class="lbl">Complemento</div><p>${os.complemento || '--'}</p></div>
      <div class="field"><div class="lbl">Bairro</div><p>${os.bairro || '--'}</p></div>
      <div class="field"><div class="lbl">Cidade</div><p>${os.cidade || '--'}</p></div>
      <div class="field"><div class="lbl">UF</div><p>${os.uf || '--'}</p></div>
      <div class="field"><div class="lbl">CEP</div><p>${os.cep || '--'}</p></div>
      ${os.lat && os.lng ? `<div class="field" style="grid-column:1/-1"><div class="lbl">Coordenadas GPS</div><p>Lat: ${Number(os.lat).toFixed(6)} / Lng: ${Number(os.lng).toFixed(6)}</p></div>` : ''}
    </div>
    <h2>Checklist</h2>
    <table><tbody>${checklistHtml}</tbody></table>
    ${os.observacoes ? `<h2>Observações</h2><p style="white-space:pre-wrap;">${os.observacoes}</p>` : ''}
    ${os.validadorNome ? `<h2>Validação</h2>
      <div class="val-box ${os.status === 'aprovada' ? 'ap-box' : 'rp-box'}">
        <strong>${os.status === 'aprovada' ? '✅ Aprovada' : '❌ Reprovada'}</strong> por ${os.validadorNome}${os.validadaEm ? ' em ' + fmt(os.validadaEm) : ''}
        ${os.comentarioValidacao ? '<br/><em>' + os.comentarioValidacao + '</em>' : ''}
      </div>` : ''}
    ${fotosHtml
      ? `<h2>Fotos (${(os.fotos || []).length})</h2><div>${fotosHtml}</div>`
      : '<h2>Fotos</h2><p style="color:#a0aec0;">Nenhuma foto anexada.</p>'}
    <div style="text-align:center;margin-top:24px;">
      <button onclick="window.print()" style="padding:10px 28px;background:${cor};color:#fff;border:none;border-radius:8px;cursor:pointer;font-size:14px;font-weight:700;">🖨️ Imprimir / Salvar PDF</button>
    </div>
  </body></html>`;
}
